import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesService {
  navigationAllowedResolve: Function;
  isRedirecting = false; // If true, the popup will not be opened.
  private _dialogSubject: BehaviorSubject<boolean>;

  constructor() {
    this._dialogSubject = new BehaviorSubject(false);
  }

  getDialogObservable(): Observable<boolean> {
    return this._dialogSubject.asObservable();
  }

  openDialog(resolve: Function): void {
    this.navigationAllowedResolve = resolve;
    this._dialogSubject.next(true);
  }

  closeDialog(acceptFlag: boolean): void {
    this.navigationAllowedResolve(acceptFlag);
  }
}
